export const reviewStatusLabels = {
  pending: "در انتظار تأیید",
  approved: "تأیید شده",
  rejected: "منتشر نشد",
};

export const isCompletedConsultation = (session) =>
  session?.status === 1 || session?.status === 2;

export const formatReviewDate = (value, includeTime = false) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return new Intl.DateTimeFormat("fa-IR", {
    timeZone: "Asia/Tehran",
    year: "numeric",
    month: "long",
    day: "numeric",
    ...(includeTime ? { hour: "2-digit", minute: "2-digit" } : {}),
  }).format(date);
};
